<template>
  <div :class="wrapperClass">
    <div
      v-for="field in fields"
      :key="`${rowKeyPrefix}-${field.key}`"
      :class="rowClass"
    >
      <span :class="labelClass">{{ $t(field.labelKey) }}</span>
      <span
        :class="valueClass(field)"
        :draggable="isFieldDraggable(field)"
        @dragstart="onFieldDragStart($event, field)"
        @dragend="onFieldDragEnd"
      >
        <GenerationHistoryPromptPopover
          v-if="field.key === 'prompt' || field.key === 'concept' || field.key === 'category_shape'"
          :text="field.value"
          :tooltip="promptTooltip"
          :interactive="promptTooltip"
        />
        <template v-else>{{ field.value }}</template>
      </span>
    </div>
  </div>
</template>

<script>
import GenerationHistoryPromptPopover from './GenerationHistoryPromptPopover.vue';

export default {
  name: 'GenerationHistoryMetaRows',
  components: {
    GenerationHistoryPromptPopover,
  },
  props: {
    fields: {
      type: Array,
      default: () => [],
    },
    variant: {
      type: String,
      default: 'inline',
      validator: (value) => ['inline', 'detail'].includes(value),
    },
    rowKeyPrefix: {
      type: String,
      default: 'meta',
    },
    promptTooltip: {
      type: Boolean,
      default: false,
    },
    canDragFields: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    wrapperClass() {
      return this.variant === 'detail' ? 'gh-meta gh-meta--horizontal' : 'gh-inline-meta';
    },
    rowClass() {
      return this.variant === 'detail' ? 'gh-meta__row' : 'gh-inline-meta__row';
    },
    labelClass() {
      return this.variant === 'detail' ? 'gh-meta__label' : 'gh-inline-meta__label';
    },
  },
  methods: {
    valueClass(field) {
      const base = this.variant === 'detail' ? 'gh-meta__value' : 'gh-inline-meta__value';
      const classes = [base];
      if (field.key === 'prompt' || field.key === 'concept' || field.key === 'category_shape') {
        classes.push(`${base}--prompt`);
      }
      if (this.isFieldDraggable(field)) {
        classes.push('gh-dnd-source');
      }
      return classes;
    },
    isFieldDraggable(field) {
      if (!field || field.draggable === false) {
        return false;
      }
      return this.canDragFields && !!(field.value && String(field.value).trim());
    },
    onFieldDragStart(event, field) {
      if (!this.isFieldDraggable(field)) {
        event.preventDefault();
        return;
      }
      this.$emit('field-drag-start', event, field);
    },
    onFieldDragEnd(event) {
      this.$emit('field-drag-end', event);
    },
  },
};
</script>
